import DefaultOrderView from './DefaultOrderView';
import ClobOrderView from './ClobOrderView';
import VoiceOrderView from './VoiceOrderView';
import IndividualTradeDisplayView from './IndividualTradeDisplayView';
import TradeDisplayView from './TradeDisplayView';

export default {
  rfq: DefaultOrderView,
  auc: DefaultOrderView,
  clob: ClobOrderView,
  voice: VoiceOrderView,
  tradeDisplay: TradeDisplayView,
  individual: IndividualTradeDisplayView
};



// WEBPACK FOOTER //
// ./src/containers/DataViewing/orderViews/index.js